<section class="wrappers d-done">
  <app-header></app-header>
  <app-navbar></app-navbar>
  <div class="content-wrapper">
    <section class="content">
      <router-outlet></router-outlet>
    </section>
  </div>

  <app-footer></app-footer>
</section>